module.exports = __webpack_public_path__ + "static/img/school.9f44ca3a.svg";